import { Box, Grid, TextField, Typography } from "@mui/material";
import { ArrowForward, Done } from "@mui/icons-material";

import Theme from "../../../../../utils/Theme";
import { SalesAidsStyles } from "./SalesAidsStyles";

const VehicleTransactionType = ({
  artifacts,
  setArtifacts,
  handleArrowClick,
  handleRemove,
}) => {
  const handleTextChange = (index, field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      vehicle_transaction_type: prev?.vehicle_transaction_type?.map(
        (item, i) =>
          i === index ? { ...item, [field]: value, isEdit: true } : item,
      ),
    }));
  };

  const handleOptionChange = (index, optionKey, value, field) => {
    setArtifacts((prev) => ({
      ...prev,
      vehicle_transaction_type: prev?.vehicle_transaction_type?.map(
        (item, i) =>
          i === index
            ? {
                ...item,
                [field]: {
                  ...item[field],
                  [optionKey]: value,
                },
                isEdit: true,
              }
            : item,
      ),
    }));
  };

  return (
    <Box sx={SalesAidsStyles.outerBox}>
      {artifacts?.map((item, index) => (
        <Box
          key={item?.id || item?.artifactId}
          sx={{
            ...SalesAidsStyles.innerBox,
            bgcolor: item?.isEdit ? "#FFF7F7" : null,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {/* ── ROW 1: English label+field | Spanish label+field ── */}
          <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
            <Box sx={{ flex: 1 }}>
              <Typography sx={SalesAidsStyles.wordStyle}>English</Typography>
              <TextField
                fullWidth
                variant="outlined"
                label="Vehicle Information"
                value={item?.vehicle_information}
                onChange={(e) =>
                  handleTextChange(index, "vehicle_information", e.target.value)
                }
                multiline
                sx={{ mt: 2 }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={SalesAidsStyles.wordStyle}>Spanish</Typography>
              <TextField
                fullWidth
                variant="outlined"
                label="Información del vehículo"
                value={item?.es_vehicle_information}
                onChange={(e) =>
                  handleTextChange(
                    index,
                    "es_vehicle_information",
                    e.target.value,
                  )
                }
                multiline
                sx={{ mt: 2 }}
              />
            </Box>
            {item?.isEdit ? (
              <Done
                sx={{
                  ...SalesAidsStyles.doneIcon,
                  color:
                    (item?.vehicle_information?.trim() &&
                      item?.vehicle_message?.trim() &&
                      item?.transaction_message?.trim()) ||
                    (item?.es_vehicle_information?.trim() &&
                      item?.es_vehicle_message?.trim() &&
                      item?.es_transaction_message?.trim())
                      ? Theme.palette.primary.main
                      : Theme.palette.action.disabled,
                  cursor:
                    (item?.vehicle_information?.trim() &&
                      item?.vehicle_message?.trim() &&
                      item?.transaction_message?.trim()) ||
                    (item?.es_vehicle_information?.trim() &&
                      item?.es_vehicle_message?.trim() &&
                      item?.es_transaction_message?.trim())
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={() =>
                  handleArrowClick(item, "vehicle_transaction_type")
                }
              />
            ) : (
              <ArrowForward
                sx={{
                  ...SalesAidsStyles.arrowForward,
                  color:
                    (item?.vehicle_information?.trim() &&
                      item?.vehicle_message?.trim() &&
                      item?.transaction_message?.trim()) ||
                    (item?.es_vehicle_information?.trim() &&
                      item?.es_vehicle_message?.trim() &&
                      item?.es_transaction_message?.trim())
                      ? Theme.palette.primary.main
                      : Theme.palette.action.disabled,
                  cursor:
                    (item?.vehicle_information?.trim() &&
                      item?.vehicle_message?.trim() &&
                      item?.transaction_message?.trim()) ||
                    (item?.es_vehicle_information?.trim() &&
                      item?.es_vehicle_message?.trim() &&
                      item?.es_transaction_message?.trim())
                      ? "pointer"
                      : "not-allowed",
                }}
                onClick={() =>
                  handleArrowClick(item, "vehicle_transaction_type")
                }
              />
            )}
          </Box>

          {/* ── ROW 2: Vehicle Type options ── */}
          <Typography sx={SalesAidsStyles.wordStyle}>Vehicle Type</Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* English side */}
            <Box
              sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Message to be displayed"
                value={item?.vehicle_message}
                onChange={(e) =>
                  handleTextChange(index, "vehicle_message", e.target.value)
                }
                multiline
              />
              <Grid container spacing={1}>
                {item?.vehicle_options && Object.entries(item.vehicle_options).map(([key, value]) => (
                  <Grid item xs={6} key={`en-${key}`}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={SalesAidsStyles.surveyButton}
                      value={value || ""}
                      onChange={(e) =>
                        handleOptionChange(
                          index,
                          key,
                          e.target.value,
                          "vehicle_options",
                        )
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Spanish side */}
            <Box
              sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Mensaje a mostrar"
                value={item?.es_vehicle_message}
                onChange={(e) =>
                  handleTextChange(index, "es_vehicle_message", e.target.value)
                }
                multiline
              />
              <Grid container spacing={1}>
                {item?.es_vehicle_options && Object.entries(item.es_vehicle_options).map(([key, value]) => (
                  <Grid item xs={6} key={`es-${key}`}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={SalesAidsStyles.surveyButton}
                      value={value || ""}
                      onChange={(e) =>
                        handleOptionChange(
                          index,
                          key,
                          e.target.value,
                          "es_vehicle_options",
                        )
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>

          {/* ── ROW 3: Transaction Type options ── */}
          <Typography sx={SalesAidsStyles.wordStyle}>
            Transaction Type
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* English side */}
            <Box
              sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Message to be displayed"
                value={item?.transaction_message}
                onChange={(e) =>
                  handleTextChange(index, "transaction_message", e.target.value)
                }
                multiline
              />
              <Grid container spacing={1}>
                {item?.transaction_options && Object.entries(item.transaction_options).map(([key, value]) => (
                  <Grid item xs={6} key={`en-${key}`}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={SalesAidsStyles.surveyButton}
                      value={value || ""}
                      onChange={(e) =>
                        handleOptionChange(
                          index,
                          key,
                          e.target.value,
                          "transaction_options",
                        )
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* Spanish side */}
            <Box
              sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}
            >
              <TextField
                fullWidth
                variant="outlined"
                label="Mensaje a mostrar"
                value={item?.es_transaction_message}
                onChange={(e) =>
                  handleTextChange(
                    index,
                    "es_transaction_message",
                    e.target.value,
                  )
                }
                multiline
              />
              <Grid container spacing={1}>
                {item?.es_transaction_options && Object.entries(item.es_transaction_options).map(([key, value]) => (
                  <Grid item xs={6} key={`es-${key}`}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={SalesAidsStyles.surveyButton}
                      value={value || ""}
                      onChange={(e) =>
                        handleOptionChange(
                          index,
                          key,
                          e.target.value,
                          "es_transaction_options",
                        )
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default VehicleTransactionType;